var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[_vm.isCard ? 'isCard' : '', ("omniview-map omniview-map-" + _vm.uuid)]})}
var staticRenderFns = []

export { render, staticRenderFns }